import { array, object, string } from "yup";

export const linkInkleSchema = object().shape({
  transactions: array().of(
    object({
      description: string().required(),
    })
  ),
});
